import React from 'react'
import { Card, Col, Row } from 'antd'
import { ModuleTopHeading, PorfessionalTable } from '../../components';

const ProfessionalPage = () => {

    
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <ModuleTopHeading level={4} name='Professionals'/>
                    </Col>
                    <Col span={24}>
                        <PorfessionalTable/>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { ProfessionalPage }
